import LazyImage from './lazy-image';
import LazyImageBackground from './lazy-image-background';
import {ImageUrlType} from './index.type';

export {LazyImageBackground};
export type {ImageUrlType};
export default LazyImage;
